import { Tab, Tabs } from "react-bootstrap";
import { Information, Possibilities, RefundList } from "../Details";
import Comments from "../../../../Common/Comments";
import css from "./tab.module.css";
import { BsReverseLayoutTextWindowReverse } from "react-icons/bs";
import { GoCommentDiscussion, GoLaw } from "react-icons/go";
import { VscLaw } from "react-icons/vsc";
import { Tb24Hours, TbSitemap } from "react-icons/tb";
import { BiMessageSquareEdit } from "react-icons/bi";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const SingleItems = ({ Item, paranetItems, details }) => {
    return (
        window.screen.width > 991
            ? <div className="singleItemTabBox">
                <Tabs
                    defaultActiveKey="Information"
                    id="uncontrolled-tab-example"
                    className={`mt-5 mb-3 ${css.tabBox}`}
                >
                    <Tab eventKey="Information" title={<span> <BsReverseLayoutTextWindowReverse size={"21px"} className="me-1" /> توضیحات</span>}>
                        <Information
                            description={Item.description}
                            name={Item.name}
                            item={Item}
                            details={details}
                        />
                    </Tab>
                    <Tab eventKey="Possibilities" title={<span> <TbSitemap size={"21px"} className="me-1" /> امکانات</span>}>
                        <Possibilities
                            description={Item.description}
                            name={Item.name}
                            item={Item}
                            details={details}
                        />
                    </Tab>

                    <Tab eventKey="registerComment" title={<span> <BiMessageSquareEdit size={"21px"} className="me-1" /> ثبت نظر </span>}>
                        <Comments showCommentList={false} comments={paranetItems.Comments} id={Item.id} rel="Item" />
                    </Tab>

                    <Tab eventKey="Comments" title={<span> <GoCommentDiscussion size={"21px"} className="me-1" /> نظرات کاربران</span>}>
                        <Comments showRegisterComment={false} comments={paranetItems.Comments} id={Item.id} rel="Item" />
                    </Tab>

                    <Tab eventKey="rules" title={<span> <VscLaw size={"21px"} className="me-1" /> قوانین و مقررات </span>}>
                        <Information description={Item.rules ? Item.rules : paranetItems.itemRules} />
                    </Tab>

                    <Tab eventKey="refundTerms" title={<span> <Tb24Hours size={"22px"} className="me-1" /> شرایط استرداد </span>}>
                        <RefundList prdId={Item.id} />
                    </Tab>

                </Tabs>
            </div>
            : <div className={"mt-3 " + (window.screen.width > 768 && "px-4")}>
                <Accordion className="mb-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content" id="panel1a-header" >
                        <span> <BsReverseLayoutTextWindowReverse size={"21px"} className="me-1" /> توضیحات</span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Information
                            description={Item.description}
                            name={Item.name}
                            item={Item}
                            details={details}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion className="mb-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <TbSitemap size={"21px"} className="me-1" /> امکانات</span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Possibilities
                            description={Item.description}
                            name={Item.name}
                            item={Item}
                            details={details}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion className="mb-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <BiMessageSquareEdit size={"21px"} className="me-1" /> ثبت نظر </span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Comments showCommentList={false} comments={paranetItems.Comments} id={Item.id} rel="Item" />
                    </AccordionDetails>
                </Accordion>

                <Accordion className="mb-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <GoCommentDiscussion size={"21px"} className="me-1" /> نظرات کاربران</span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Comments showRegisterComment={false} comments={paranetItems.Comments} id={Item.id} rel="Item" />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <VscLaw size={"21px"} className="me-1" /> قوانین و مقررات </span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Information description={Item.rules ? Item.rules : paranetItems.itemRules} />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <Tb24Hours size={"21px"} className="me-1" />  شرایط استرداد </span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <RefundList prdId={Item.id} />
                    </AccordionDetails>
                </Accordion>
            </div>

    )
}
export default SingleItems